import styled from 'styled-components';
import { onSurface, onSurfaceVariant, outlineVariant, primary, radiusFull, surface, surfaceHigh } from '../themeTokens';

export const StatusLayer = styled.div<{ $blocking: boolean }>`
  position: absolute;
  inset: 0;
  z-index: 5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 16px;
  text-align: center;
  font-size: 13px;
  color: ${onSurfaceVariant};
  background: ${(p) => (p.$blocking ? surface(p) : 'transparent')};
  pointer-events: ${(p) => (p.$blocking ? 'auto' : 'none')};
`;

export const EmptyNote = styled.span`
  padding: 6px 14px;
  border-radius: ${radiusFull};
  background: color-mix(in srgb, ${surface} 82%, transparent);
  backdrop-filter: blur(6px);
`;

export const RetryButton = styled.button`
  padding: 6px 16px;
  border-radius: ${radiusFull};
  border: 1px solid ${outlineVariant};
  background: transparent;
  color: ${onSurface};
  font-size: 13px;
  cursor: pointer;
  transition: background 150ms ease;

  &:hover {
    background: ${surfaceHigh};
  }

  &:focus-visible {
    outline: 2px solid ${primary};
    outline-offset: 2px;
  }
`;
